import clsx from "clsx"
import { npPagePxClassName, npPageWidthClassName } from "src/components/np-design/components/constants"
import { ListProductData } from "src/data/product-list/types"
import { TrackViewItemList } from "src/tracking/TrackViewItemList"
import { ProductListAction, ProductListItem } from "./ProductListItem"

export type ProductListProps = {
  listId: string
  products: ListProductData[]
  action?: ProductListAction
}

/**
 * @deprecated Do not use this component directly as it does not contain
 * tracking. — Use `FilterableProductList` or `NonFilterableProductList` instead.
 */
export const ProductList = ({ listId, products, action }: ProductListProps) => {
  return (
    <>
      <TrackViewItemList listId={listId} products={products} />

      <section aria-label="Produkte" className={npPagePxClassName}>
        <div
          className={clsx(
            npPageWidthClassName,
            "flex flex-col items-center justify-center gap-x-8 gap-y-12 lg:flex-row lg:flex-wrap lg:items-stretch",
          )}
        >
          {products.map((product) => (
            <ProductListItem key={product.id} listId={listId} product={product} action={action} />
          ))}
        </div>
      </section>
    </>
  )
}
